export const sideMenuConfig = [
  { label: 'Dashboard', url: '/' },
  { label: 'Contacts', url: '/contacts' },
  { label: 'Tasks', url: '/tasks' },
  { label: 'Segments', url: '/segments' },
  { label: 'Assigned Voters', url: '/assigned-voters' },
  { label: 'Manage Team', url: '/manage-team' },
  { label: 'Campaigns', url: '/campaigns' },
  { label: 'Surveys', url: '/surveys' },
  { label: 'Audit Log', url: '/audit-log' },
  { label: 'Settings', url: '/settings' },
];

export const ORG_JOIN_PENDING = 'org-join-pending';
export const DEFAULT_ERROR_MESSAGE = 'Something went wrong!';
export const UNIQUE_ATTRIBUTE_ERROR = 'This attribute must be unique';
export const REQUIED_ERROR_MESSAGE = 'Please fill this field';
export const ethnicityOptions = [
  'Asian',
  'Black or African American',
  'Hispanic or Latino',
  'Native American or Alaska Native',
  'White',
  'Other'
];

export const religionOptions = [
  'Christian',
  'Protestant',
  'Catholic',
  'Orthodox',
  'Greek Orthodox',
  'Eastern Orthodox',
  'Islamic',
  'Hindu',
  'Buddhist',
  'Jewish',
  'Sikh',
  'Lutheran',
  'Mormon',
  'Shinto',
  'Atheist',
  'Agnostic',
  'Other'
];

export const placesOfWorshipOptions = [
  'Church',
  'Mosque',
  'Temple',
  'Synagogue',
  'Gurdwara',
  'Monastery',
  'Pagoda',
  'Shrine',
  'Other'
];

export const likelinessToVoteOptions = [
  'Very Likely',
  'High Potential',
  'Possible',
  'Unlikely',
  'Highly Unlikely'
];

export const SUPPORT_LEVELS = [
  {label: 'Strong Support', value: 'strong_support'},
  {label: 'Weak Support', value: 'weak_support'},
  {label: 'Undecided', value: 'undecided'},
  {label: 'Weak Oppose', value: 'weak_oppose'},
  {label: 'Strong Oppose', value: 'strong_oppose'},
];

export const GENDER_OPTIONS = [
  {label: 'Male', value: 'M'},
  {label: 'Female', value: 'F'},
  {label: 'Other', value: 'O'},
];

export const roleNames = {
  admin: 'admin',
  teammanager: 'team-manager',
  volunteer: 'volunteer'
}

export const MARITAL_STATUS_OPTIONS = [
  {value: 'single', label: 'Single'},
  {value: 'married', label: 'Married'},
  {value: 'seperated', label: 'Seperated'},
  {value: 'widowed', label: 'Widowed'},
  {value: 'civil union', label: 'Civil Union'},
  {value: 'divorced', label: 'Divorced'},
  {value: 'domestic partner', label: 'Domestic Partner'},
];